const createDateFromString = (dateString) => {
  if (!dateString) return new Date();
  return new Date(dateString.split("/").reverse().join("-"));
};

export const dateFormat = (dateOptions, date) => {
  return new Intl.DateTimeFormat("en-GB", dateOptions).format(date);
};

export const formatDateToStartOfDay = (dateString) => {
  const date = createDateFromString(dateString);
  date.setHours(0, 0, 0, 0);
  return date.getTime();
};

export const formatDateToEndOfDay = (dateString) => {
  const date = createDateFromString(dateString);
  date.setHours(23, 59, 59, 999);
  return date.getTime();
};
